import React from 'react'
import { SearchOutlined } from '@material-ui/icons'

import './emptyStateConversations.css'

const EmptyStateConversations = () => {

  const PF = process.env.REACT_APP_PUBLIC_FOLDER

  const handleSearch = () => {
    document.querySelector(".searchInput").focus()
  }

  return (
    <div className='esConversationsWrapper'>
        <div className='esConversationsImgWrapper'>
          <img src={PF + 'person/noconversations.png'} alt="" className='esConversationsImg'/>
        </div>
        <p className='noConversationsYet'>No Conversations yet</p>
        <p className='startConvo'>Start a conversation and make some friends</p>
        <button className='searchFriends' onClick={handleSearch}>
          <SearchOutlined />
          Search some friends
        </button>
    </div>
  )
}

export default EmptyStateConversations